import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Menu from './components/Menu';
import TicketMachine from './components/TicketMachine';
import LocalVideoPlayer from './components/LocalVideoPlayer';
import SpeechSynthesisComponent from './components/SpeechSynthesisComponent';
import { useSearchParams } from 'react-router-dom';
// import ImageDisplay from './ImageDisplay';

const TypeComponent = () => {
  const [searchParams] = useSearchParams();
  const type = typeof searchParams.get('type') === 'object' ? '' : searchParams.get('type').toLowerCase();
  const debugTest = searchParams.get('test');
  // eslint-disable-next-line no-unused-vars
  const [currentTestPreparingData, setCurrentTestPreparingData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [currentTestDoneData, setCurrentTestDoneData] = useState([]);
  // const [currentTestClearData, setCurrentTestClearData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [currentTestSoldoutData, setCurrentTestSoldoutData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputWaitValue, setInputWaitValue] = useState("");

  // 定義產生隨機字串陣列的函數
  // eslint-disable-next-line no-unused-vars
  const generateRandomStringArray = () => {
    // 產生隨機的陣列長度，範圍在1到10之間
    const length = Math.floor(Math.random() * 10) + 1;
    
    // 生成隨機數字字串陣列
    const array = Array.from({ length }, () => {
      // 產生一個0到998之間的隨機整數
      const randomNumber = Math.floor(Math.random() * 999);
      // 將數字轉換為長度為3的字串，前面補0
      return randomNumber.toString().padStart(3, '0');
    });
    
    return array;
  };

  // eslint-disable-next-line no-unused-vars
  const simulateLoadUrl = (data) => {
    console.log("simulateLoadUrl get data:", data);
    // window.getOrderStatus(data);
    if (type === 'ticketmachine') {
      window.getOrderStatus(data);
    } else {
      window.getSoldoutItem(data);
    }
  };

  switch (type) {
    case 'voice':
      return <SpeechSynthesisComponent />;
    case 'menu':
      if (debugTest){
        return (
          <>
            <Menu />
            <input className='input-1' value={inputValue}
              placeholder='請輸入品項代號(一次一筆)'
              // type='number'
              // pattern='[0-9]+([\,|\.][0-9]+)?'
              onChange={(e)=> {
                setInputValue(e.target.value);
            }}
            />
            <button className='btn-1' onClick={() => {
              // const newData1 = generateRandomStringArray();
              if (inputValue && inputValue !== "") {
                const newData1 = [inputValue];
                setCurrentTestSoldoutData(newData1);
                console.log("currentTestSoldoutData:", newData1);
                simulateLoadUrl({soldOut: newData1})
              } else {
                window.alert("輸入欄位請勿為空白");
              }}
            }>
              產生'品項售完'遮罩
            </button>
          </>
        
        );
      } else {
        return <Menu />;
      }
    case 'ticketmachine':
      // 測試模式
      if (debugTest){
        return (
          <div>
            <TicketMachine />
            <input className='input-1' value={inputValue}
              placeholder='請輸入訂單號碼(一次一筆)'
              // type='number'
              // pattern='[0-9]+([\,|\.][0-9]+)?'
              onChange={(e)=> {
                setInputValue(e.target.value);
            }}
            />
            <button className='btn-1' onClick={() => {
              // const newData1 = generateRandomStringArray();
              if (inputValue && inputValue !== "") {
                const newData1 = [inputValue];
                setCurrentTestPreparingData(newData1);
                console.log("currentTestPreparingData:", newData1);
                simulateLoadUrl({preparing: newData1, done: [], clear: []})
              } else {
                window.alert("輸入欄位請勿為空白");
              }}
            }>
              產生 '製作中' 號碼
            </button>
            <button className='btn-2' onClick={() => {
              // const newData2 = generateRandomStringArray();
              if (inputValue && inputValue !== "") {
                const newData2 = [inputValue];
                setCurrentTestDoneData(newData2);
                console.log("currentTestDoneData:", newData2);
                simulateLoadUrl({preparing: [], done: newData2, clear: []})
              } else {
                window.alert("輸入欄位請勿為空白");
              }}
            }>
              產生 '請取餐' 號碼
            </button>
            <input className='input-2' value={inputWaitValue}
              placeholder='請輸入杯數或者等待分鐘數'
              type='number'
              pattern='[0-9]+([\,|\.][0-9]+)?'
              onChange={(e)=> {
                console.log("e.target.value : ", e.target.value);
                setInputWaitValue(e.target.value);
            }}
            />
            <button className='btn-6' onClick={() => {
              // const newData1 = generateRandomStringArray();
              if (inputWaitValue && inputWaitValue !== "") {
                const newData1 = Number(inputWaitValue);
                // setCurrentTestPreparingData(newData1);
                console.log("current Test Cup Data:", newData1);
                simulateLoadUrl({preparing: [], done: [], clear: [], totalAmount: newData1})
              } else {
                window.alert("輸入欄位請勿為空白");
              }}
            }>
              產生 杯數
            </button>
            <button className='btn-7' onClick={() => {
              // const newData2 = generateRandomStringArray();
              if (inputWaitValue && inputWaitValue !== "") {
                const newData2 = Number(inputWaitValue);
                // setCurrentTestDoneData(newData2);
                console.log("current Test Min Data:", newData2);
                simulateLoadUrl({preparing: [], done: [], clear: [], totalTime: newData2})
              } else {
                window.alert("輸入欄位請勿為空白");
              }}
            }>
              產生 等待分鐘
            </button>
            {/* <button className='btn-3' onClick={() => simulateLoadUrl({preparing: generateRandomStringArray(), done: generateRandomStringArray(), clear: []})}>
              隨機產生 'preparing' and 'done'
            </button> */}
            <button className='btn-4' onClick={() => {
              // simulateLoadUrl({preparing: [], done: [], clear: currentTestPreparingData});
              if (inputValue && inputValue !== "") {
                const newData = [inputValue];
                // setCurrentTestPreparingData(newData2);
                console.log("currentTest clear preparing Data:", newData);
                simulateLoadUrl({preparing: [], done: [], clear: newData})
              } else {
                window.alert("輸入欄位請勿為空白");
              }
            }}>
              清除指定訂單編號
            </button>
            {/* <button className='btn-5' onClick={() => simulateLoadUrl({preparing: [], done: [], clear: currentTestDoneData})}>
              清除 請取餐
            </button> */}
            <span className='clear-hint'>如果要清除所有訂單請重新整理網頁</span>
          </div>
        );

      // 正常模式
      } else {
        return <TicketMachine />;
      }

    default:
      return <LocalVideoPlayer/>;
  }
};

function App() {
  return (
    // <Router>
    //   <Routes>
    //     <Route path="/" element={<ImageDisplay />} />
    //   </Routes>
    // </Router>
    <Router>
      <Routes>
        {/* <Route path="/:type" element={<Menu />} />
        <Route path="/:type" element={<TicketMachine />} /> */}
        <Route path="/" element={<TypeComponent />} />
        <Route path="*" element={<LocalVideoPlayer/>} />
      </Routes>
    </Router>
  );
}

export default App;
